import { useEffect, useState } from 'react';
import contractsService from '../services/contracts.service';

/** Whether the person's Membership Agreement is approved (S-41), read once when `enabled`.
 *  Null while reading, when not asked, or when it could not be read: the screen then offers
 *  what it did before and the server's own rule still answers. */
export function useMembershipApproved(enabled: boolean): boolean | null {
  const [approved, setApproved] = useState<boolean | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    contractsService
      .getMembership()
      .then((status) => {
        if (!cancelled) setApproved(status.approved);
      })
      .catch(() => {
        if (!cancelled) setApproved(null);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return enabled ? approved : null;
}
